import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

function TypesOfInvestments() {
  const { t } = useTranslation(); // 預設 namespace: 'translation'

  return (
    <div className="article-container">
      <h1>{t('typesOfInvestments.title')}</h1>

      <h2>{t('typesOfInvestments.stocksHeading')}</h2>
      <p>{t('typesOfInvestments.stocksParagraph')}</p>

      <h2>{t('typesOfInvestments.bondsHeading')}</h2>
      <p>{t('typesOfInvestments.bondsParagraph')}</p>

      <h2>{t('typesOfInvestments.cryptocurrenciesHeading')}</h2>
      <p>{t('typesOfInvestments.cryptocurrenciesParagraph')}</p>

      <h2>{t('typesOfInvestments.realEstateHeading')}</h2>
      <p>{t('typesOfInvestments.realEstateParagraph')}</p>

      <h2>{t('typesOfInvestments.mutualFundsHeading')}</h2>
      <p>{t('typesOfInvestments.mutualFundsParagraph')}</p>

      <h2>{t('typesOfInvestments.commoditiesHeading')}</h2>
      <p>{t('typesOfInvestments.commoditiesParagraph')}</p>

      <h2>{t('typesOfInvestments.alternativeHeading')}</h2>
      <p>{t('typesOfInvestments.alternativeParagraph')}</p>
    </div>
  );
}

export default TypesOfInvestments;
